import getApiClient from '@/plugins/api';
import cpfValid from '@/plugins/cpfValid';

const moment = require('moment')

export default {
    clearForm() {
        this.customer.id = null;
        this.customer.name = null;
        this.customer.email = null;
        this.customer.phone = null;
    },

    blockFields() {
        this.blockField.name = false;
        this.blockField.email = false;
        this.blockField.phone = false;
    },

    validateDocument(cpf) {

        this.resetPlace();

        if (cpf.length < 11) {
            // Clear message
            this.setMessageCustomerDocument();

            // Clear document consultation
            this.documentConsultation = null;

            this.clearForm();
            this.blockFields();
            this.resetRegisterErrors();

            return false;
        }

        this.customer.cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4');

        if (!cpfValid(cpf)) {
            this.setMessageCustomerDocument(this.documentInvalid);
            return false;
        }

        if (cpf === this.documentConsultation) {
            return false;
        }

        return true;
    },

    recoverCustomer(event) {
        const self = this;
        const api = getApiClient(this.$store);
        let cpf = this.customer.cpf?.replace(/[.-]/g, '');

        if (!this.validateDocument(cpf)) {
            return;
        }

        this.isPreRegistration = false;

        // Clear message
        self.setMessageCustomerForm();

        this.$store.commit('startLoading');

        api.get(`customers/get?cpf=${cpf}`)
            .then((result) => {
                let data = result.data['hydra:member'];
                self.documentConsultation = cpf;

                if (data.length === 0) {
                    self.isPreRegistration = true;

                    self.clearForm();
                    self.blockFields();

                    self.setMessageCustomerDocument(self.customerNotExist);
                    return;
                }

                self.setMessageCustomerDocument(self.customerExists);

                data = data.shift();

                self.customer.id = data.id;
                self.customer.name = data.name;
                self.customer.rg = data.rg;
                self.customer.phone = data.user?.phone?.replace(/^(\d{2})(\d{4})(\d{5}).*/, '($1) $2-$3');
                self.customer.email = data.user?.email;

                self.blockField.name = self.customer.name ? true : false;
                self.blockField.rg = self.customer.rg ? true : false;
                self.blockField.email = self.customer.email ? true : false;
                self.blockField.phone = self.customer.phone ? true : false;
            })
            .catch((error) => {
                self.setMessageCustomerForm(self.serverError, 'danger')
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    processForm() {
        this.resetRegisterErrors();

        if (!this.validateForm()) {
            return;
        }

        if (this.isPreRegistration) {
            return this.registerUser();
        }

        this.updateUser();
    },

    registerUser() {
        const self = this,
            api = getApiClient(self.$store);

        self.$store.commit('startLoading');

        let object = {
            name: self.customer.name,
            cpf: self.customer.cpf.replace(/[^0-9]+/g, ''),
            rg: self.customer.rg.replace(/[^0-9]+/g, ''),
            user: {
                phone: self.customer?.phone?.replace(/[^0-9]+/g, ''),
                email: self.customer.email,
            },
            cart: [
                {
                    trip: `/trips/${self.customer.place}`,
                    accommodations: self.customer.accommodations,
                    optionals: self.customer.optionals
                }
            ]
        };

        api.post('customers/register', object)
            .then((result) => {
                self.resetForm();
                self.setMessageCustomerForm(self.registeredCustomer, 'success');
            })
            .catch(error => {
                switch (error.response?.status ?? null) {
                    case 400:
                    case 422:
                        self.setMessageCustomerForm(self.invalidData, 'danger')
                        break;
                    default:
                        self.setMessageCustomerForm(self.serverError, 'danger')
                        break;
                }
            })
            .finally(() => {
                this.$store.commit('stopLoading');
            });
    },

    updateUser() {
        const self = this,
            api = getApiClient(self.$store);

        self.$store.commit('startLoading');

        let object = {
            phone: self.customer.phone.replace(/[^0-9]+/g, ''),
            email: self.customer.email,
            trip: self.customer.place,
            accommodations: self.customer.accommodations
        }

        api.patch(`customer/update/${self.customer.id}`, object, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                self.resetForm();
                self.setMessageCustomerForm(self.updatedClient, 'success');
            })
            .catch((error) => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        self.setMessageCustomerForm(self.invalidData, 'danger')
                        break;
                    default:
                        self.setMessageCustomerForm(self.serverError, 'danger')
                        break;
                }
            })
            .finally(() => {
                self.$store.commit('stopLoading');
            });
    },

    validateForm() {
        let countError = 0;

        Object.keys(this.error).map((value, index) => {
            countError += this.validateInput(value) ? 1 : 0;
        });

        return countError === 0;
    },

    validateInput(value) {
        this.error[value] = null;
        if (value === 'phone') {
            return false
        }

        if (this.customer[value] === '' || this.customer[value] === null) {
            this.error[value] = `Por favor preencher esse campo.`;
        }

        if (value === 'cpf') {
            cpfValid(this.customer[value]);
        }

        return this.error[value] ? true : false;
    },

    resetRegisterErrors() {
        this.codeError = null;

        Object.keys(this.error).map((value, index) => {
            this.error[value] = null;
        });
    },

    resetRegister() {
        Object.keys(this.customer).map((value, index) => {
            if(value === 'cpf' || value === 'place') {
                return;
            }

            this.customer[value] = null
        });
    },

    resetForm() {
        this.documentConsultation = null;
        this.setMessageCustomerDocument();

        Object.keys(this.customer).map((value, index) => {
            this.customer[value] = null;
        });

        this.customer.accommodations = []
        this.customer.optionals = []

        this.resetPlace();
    },

    customResultsDisplay: function(data) {
        return `${data.eventTitle} (${moment(data.startTime).format("DD/MM/YYYY")})`
    },

    setPlace: function (data) {
        this.customer.place = data.value
        this.customer.accommodations = []
        this.customer.optionals = []
        this.trip = data.selectedObject
    },

    resetPlace: function () {
        this.customer.place = null;
        this.customer.accommodations = []
        this.customer.optionals = []
        this.trip = null
    },

    setMessageCustomerForm: function (message = null, type = null) {
        this.messageCustomerForm = message;
        this.messageTypeCustomerForm = type;
    },

    setMessageCustomerDocument: function (message = null) {
        this.messageCustomerDocument = message;
    },

    isFieldDisabled: function (value, block) {
        return (!value && this.documentConsultation === null)
            || (block && this.documentConsultation !== null);
    },

    getSelectedAccommodation(accommodationId) {
        return this.customer?.accommodations?.filter(accommodation => {
            return accommodation.id === accommodationId
        })?.pop()
    },

    selectAccommodation(accommodationPeopleTypeValue, accommodation) {
        const isSelected = this.getSelectedAccommodation(accommodationPeopleTypeValue.id)

        if (isSelected) {
            this.removeAccommodation(accommodationPeopleTypeValue.id)
            accommodationPeopleTypeValue.quantity = 0
            return
        }

        console.log(accommodation)
        if (accommodation.vacancies) {
            this.customer.accommodations.push(accommodationPeopleTypeValue)
            accommodationPeopleTypeValue.quantity = 1
        }
    },

    removeAccommodation(accommodationId) {
        this.customer.accommodations = this.customer.accommodations.filter(accommodation => {
            return accommodation.id !== accommodationId
        })
    },

    updateAccommodationSelection(accommodation) {
        const isSelected = this.getSelectedAccommodation(accommodation.id)
        if (! accommodation.quantity) {
            accommodation.quantity = 0
        }
        if (isSelected) {
            isSelected.quantity = accommodation.quantity
        }
        if (accommodation.quantity > 0 && !isSelected) {
            this.customer.accommodations.push(accommodation)
            return
        }

        if (!accommodation.quantity && isSelected) {
            this.removeAccommodation(accommodation.id)
            return
        }
    },




    getSelectedOptional(optionalId) {
        return this.customer?.optionals?.filter(optional => {
            return optional.id === optionalId
        })?.pop()
    },

    removeOptional(optionalId) {
        this.customer.optionals = this.customer.optionals.filter(optional => {
            return optional.id !== optionalId
        })
    },

    selectOptional(optional) {
        const isSelected = this.getSelectedOptional(optional.id)

        if (isSelected) {
            this.removeOptional(optional.id)
            optional.quantity = 0
            return
        }

        this.customer.optionals.push(optional)
        optional.quantity = 1
    },

    updateOptionalSelection(optional) {
        const isSelected = this.getSelectedOptional(optional.id)
        if (! optional.quantity) {
            optional.quantity = 0
        }
        if (isSelected) {
            isSelected.quantity = optional.quantity
        }
        if (optional.quantity > 0 && !isSelected) {
            this.customer.optionals.push(optional)
            return
        }

        if (!optional.quantity && isSelected) {
            this.removeOptional(optional.id)
            return
        }
    },
}
